export { HyperBench as default } from './hyperbench';
